<template>
  <b-card v-if="surveyImprovement" class="survey-improvement-card">
    <div class="d-flex flex-column h-100">
      <div class="row align-items-start no-gutters mb-0">
        <div class="col">
          <font-awesome-icon :icon="['fal', 'clipboard-check']" size="lg" />
          <b-link
            :to="{ name: to, params: { id: surveyImprovement.SurveyImprovementId } }">
            <h6 class="mb-1 d-inline">
              <u>{{ $t("Webportal.Actions.SurveyImprovement") }} #{{ surveyImprovement.SurveyImprovementVisibleId }}</u>
            </h6>
          </b-link>
        </div>
        <div class="col-auto pl-2">
          <b-badge class="survey-improvement-item font-weight-normal d-block" variant="primary" pill>
            <font-awesome-icon :icon="['far', getImprovementStatusIcon(surveyImprovement.StatusId)]" />
            {{ getImprovementStatusText(surveyImprovement.StatusId) }}
          </b-badge>
        </div>
      </div>

      <small class="mt-auto text-muted border-top pt-1">
        {{ getImprovementLastUpdatedText(surveyImprovement) }}
      </small>
    </div>
  </b-card>
</template>

<script>
import AppConfig from '@/mixins/AppConfig';
import SurveyImprovementMixin from "@/mixins/SurveyImprovementMixin";

export default {
  name: "SurveyImprovementCard",

  mixins: [AppConfig, SurveyImprovementMixin],

  props: {
    surveyImprovement: null,
    to: { default: "SurveyImprovement" },
  },
};
</script>
